import Shaps from "./Shapes";
import { GAP_RATIO, DRAW_RATIO } from "../constant";
import { transRgbBySrgb } from "../utils/common";

export default class Rect extends Shaps {
  constructor(data) {
    super(data);
  }

  /**
   * 绘制动作
   */
  draw() {
    const { SRGB_List, drawOption, containerDom } = this.data;
    const { width, height, gapRatio = GAP_RATIO, drawRatio = DRAW_RATIO, autoHeight = false } = drawOption;

    const { containerWidth, containerHeight } = this.calContainerSize(
      width || containerDom.offsetWidth,
      height || containerDom.offsetHeight
    );

    // 计算每个有色模块的宽度
    const { blockWidth, blockAndGrapWidth } = this.calBlockOption(
      containerWidth,
      this.data.originImgData.width,
      gapRatio,
      drawRatio
    );

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext("2d");

    // canvas画布按倍率(默认2)绘制 最后scale 0.5 提高清晰度 
    canvas.width = containerWidth * drawRatio;
    canvas.height = containerHeight * drawRatio;
    canvas.style.transform = `scale(${1 / drawRatio})`;
    canvas.style[`transform-origin`] = '0 0';

    // 不设置盒子高度则自动等比自适应
    if (autoHeight) {
      containerDom.style.height = `${containerHeight}px`;
    }

    const SRGB_List_Length = SRGB_List.length;
    const originImgWidth = this.data.originImgData.width;

    // 按rgb数据绘制每个模块的颜色
    for (let i = 0; i < SRGB_List_Length; i++) {
      const xPos = i % originImgWidth;
      const yPos = Math.floor(i / originImgWidth);
      ctx.beginPath();
      ctx.fillStyle = transRgbBySrgb(SRGB_List[i]);
      
      ctx.rect(
        xPos * blockAndGrapWidth,
        yPos * blockAndGrapWidth,
        blockWidth,
        blockWidth
      );
      ctx.fill();
      ctx.closePath();
    }

    this.data.bitmapCtx = ctx;

    containerDom.appendChild(canvas);

    this.dispatch('onDrawEnd', {
      bitmapCtx: ctx
    })
  }
}